/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Settings_Storage_DescriptionInputs */

const es_walkthrough_settings_storage_description = /** @type {(inputs: Walkthrough_Settings_Storage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectá fuentes de datos externas que manejan archivos, como Google Drive, OneDrive o Dropbox. Desde acá podés conectar las fuentes e ir seleccionando archivos para ingestarlos en Nexata.`)
};

const en_walkthrough_settings_storage_description = /** @type {(inputs: Walkthrough_Settings_Storage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect external data sources that handle files, such as Google Drive, OneDrive, or Dropbox. From here you can connect the sources and select files to ingest into Nexata.`)
};

/**
* | output |
* | --- |
* | "Connect external data sources that handle files, such as Google Drive, OneDrive, or Dropbox. From here you can connect the sources and select files to ingest..." |
*
* @param {Walkthrough_Settings_Storage_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_settings_storage_description = /** @type {((inputs?: Walkthrough_Settings_Storage_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Settings_Storage_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_settings_storage_description(inputs)
	return en_walkthrough_settings_storage_description(inputs)
});
export { walkthrough_settings_storage_description as "walkthrough.settings_storage_description" }